// import { getBuyerJWTToken } from '@common/utils/token';
import Review from '@common/models/Review';
import { fetchNextPageProductReviewsRequest } from '@common/store/productDetails/slice';
// import { isMobile } from '@common/utils';
import { getBuyerJWTToken } from '@common/utils/token';
import StarRating from '@components/Rating/StarRating';
import { LoaderIcon } from '@instamojo/icons';
import Link from '@lib/Link';
import classNames from 'classnames';
// import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';

// import { ReactComponent as StarIcon } from '@common/icons/Star.svg';
// import Ratingbar from './Ratingbar';
// import StarRating from './StarRating';
import ReviewComponent from './Review';

// import Carousel from '@brainhubeu/react-carousel';

export interface RatingProps {
  reviews: Array<Review>;
  productSlug?: string;
  rating?: string;
  fetchNextPageProductReviewsRequest: typeof fetchNextPageProductReviewsRequest;
  nextReviewsUrl: string | null;
  reviewsCount: number;
  isNextReviewsLoading: boolean;
  isNextReviewsLoadingFailed: boolean;
}

const Rating: React.FunctionComponent<RatingProps> = ({
  reviews = [],
  productSlug,
  rating,
  fetchNextPageProductReviewsRequest,
  nextReviewsUrl,
  reviewsCount,
  isNextReviewsLoading,
  isNextReviewsLoadingFailed,
}) => {
  return (
    <div id="Review" className={'flex flex-col md:flex-row flex-wrap rounded-md'}>
      <div className={classNames('flex flex-col w-full')}>
        <div
          className={classNames(
            'flex flex-col md:flex-row w-full items-center md:pt-40 mb-34 md:border-t border-shareBorder',
            {
              'justify-center': !reviewsCount,
              'justify-between': reviewsCount,
            },
          )}
          font-customisation="para-text"
        >
          {reviewsCount > 0 && (
            <div className="flex flex-col w-full">
              <div
                className="text-16 md:text-18 leading-26 text-textColor mb-4 font-normal flex text-left"
                color-customisation="page-body-text"
              >
                {reviewsCount} {reviewsCount > 1 ? 'users ' : 'user '}
                have give this product a rating of
              </div>
              {parseInt(rating) > 0 ? (
                <div className="flex mt-10 md:mt-4 justify-start ">
                  <StarRating
                    rating={parseInt(rating) ? parseInt(rating) : 0}
                    halfRating={parseInt(rating) ? (Number.isInteger(rating) ? 0 : 1) : 0}
                    total={5}
                    isInteractive={false}
                    className="mr-10 h-18 w-18 min-w-18 min-h-18"
                  />
                </div>
              ) : null}
            </div>
          )}
          <div className={classNames('flex flex-col md:flex-row mt-20 md:mt-0 items-center gap-20 w-full md:w-auto')}>
            {/* <div className="text-couponDesc_2 text-18 leading-22 font-medium">Review this product</div> */}
            <button
              type="submit"
              className="font-semibold text-18 md:text-16 leading-19 md:leading-16 min-w-full md:min-w-148 h-44 md:h-40 w-full md:w-160 text-textColor bg-white flex justify-center items-center  cursor-pointer border border-btnBorder rounded-3"
              button-customisation="page-button"
            >
              <Link
                to={
                  getBuyerJWTToken()
                    ? `/product/${productSlug}/review`
                    : `/account/login?redirect_url=/product/${productSlug}/review`
                }
              >
                Write a Review
              </Link>
            </button>
          </div>
        </div>
        {reviewsCount > 0 && (
          <div className="">
            <div className="grid">
              {reviews.map((review) => (
                <ReviewComponent
                  key={review.id}
                  name={review.customerName}
                  date={review.created}
                  review={review.review}
                  rating={review.rating}
                />
              ))}
            </div>
            {isNextReviewsLoading && !isNextReviewsLoadingFailed && (
              <div className="flex justify-center py-10 md:pl-4 md:justify-start">
                <LoaderIcon size={35} />
              </div>
            )}
            {nextReviewsUrl && (
              <button
                className="font-semibold text-18 md:text-16 leading-19 md:leading-16 min-w-full md:min-w-148 h-44 md:h-40 w-full md:w-160 text-textColor flex justify-center items-center  cursor-pointer border border-btnBorder rounded-3"
                onClick={() => {
                  fetchNextPageProductReviewsRequest({
                    nextReviewsUrlPageNo: nextReviewsUrl,
                    productSlug: productSlug,
                  });
                }}
              >
                View More Reviews
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default connect(null, { fetchNextPageProductReviewsRequest })(Rating);
